// src/layouts/AppShell.jsx
import React, { useContext, useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./components/Header/Header";
import StudentMobileTopBar from "./components/Header/StudentMobileTopBar";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import PopupUI from "./components/Common/PopupUI";
import SubPopupUI from "./components/Common/SubPopupUI";
import StaffChatWorkspaceHost from "./components/Popups/StaffChatWorkspaceHost";
import StudentMandatoryRatingsGate from "./components/Utils/StudentMandatoryRatingsGate";
import NotificationToastStack from "./components/Utils/NotificationToastStack";
import { UserContext } from "./UserContext";
import { setStaffChatAsWorkspace } from "./components/Common/popupUIStore";
import { closeStaffChatWorkspace } from "./stores/staffChatWorkspaceStore";
import { normalizeRole, ROLES } from "./auth/access";

export default function AppShell() {
   const { pathname } = useLocation();
   const { user } = useContext(UserContext);

   const isStudentRoute = useMemo(
      () => pathname === "/student" || pathname.startsWith("/student/"),
      [pathname],
   );
   const showStudentMobileTopBar =
      isStudentRoute && String(user?.role || "").toUpperCase() === "USER";

   // panoul plutitor de mesaje: doar admin și manager (vezi popupUIStore)
   const role = normalizeRole(user?.role);
   const staffChatAsWorkspace = role === ROLES.ADMIN || role === ROLES.MANAGER;
   useEffect(() => {
      setStaffChatAsWorkspace(staffChatAsWorkspace);
      if (!staffChatAsWorkspace) closeStaffChatWorkspace();
   }, [staffChatAsWorkspace]);

   useEffect(() => {
      document.body.classList.toggle(
         "student-mobile-topbar-enabled",
         showStudentMobileTopBar,
      );
      return () => document.body.classList.remove("student-mobile-topbar-enabled");
   }, [showStudentMobileTopBar]);

   return (
      <>
         <Header />
         {showStudentMobileTopBar && (
            <StudentMobileTopBar showEdit={pathname === "/student"} />
         )}
         <ErrorBoundary
            name="popups"
            resetKey={pathname}
            title="Ceva s-a rupt în această fereastră"
         >
            <PopupUI />
            <SubPopupUI />
            <StaffChatWorkspaceHost />
         </ErrorBoundary>
         <NotificationToastStack />
         <StudentMandatoryRatingsGate />
         {/* aici intră paginile */}
         <ErrorBoundary name="route" resetKey={pathname}>
            <Outlet />
         </ErrorBoundary>
      </>
   );
}
